<div class="internalcard">
    <div class="data">
        <!-- TÍTOL -->
        <div class="line route-title ellipsis">
            {{route.title}}
            <span class="route-titlesubtitle">{{route.titleSubtitle}}</span>
        </div>

        <!-- SUBTÍTOL -->
        <div class="line route-subtitle ellipsis">{{route.subtitle}}
        </div>

        <!-- DATES -->
        <div class="line route-description ellipsis no-mini" *ngIf="route.line1">{{ route.line1 }}
        </div>
        <div class="line route-description ellipsis disp no-mini" *ngIf="route.line2">{{ route.line2 }}
        </div>
        <div class="line route-description ellipsis no-mini" *ngIf="route.line3">{{ route.line3 }}
        </div>

        <!-- RETAÏLA D'ETIQUETES -->
        <shared-tags-strip-component class="only-single no-mini no-reduced"
            [tags]="route.userTags"></shared-tags-strip-component>
    </div>
    <div class="bottom-zone">
        <shared-route-strip-component [route]="route"
            class="noStatus noSlot noExwork noCarrier in-bottom-zone"></shared-route-strip-component>
    </div>
</div>